import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';

const EditOrganization = React.lazy(() => import('./EditOrganization'));

function EditOrganizationPage(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>تغییر اسلاگ برگزارکننده</PageTitle>
        <Button as={Link} type="anchor" to="/organizations">
          بازگشت به لیست
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <EditOrganization {...props} />
      </Suspense>
    </Page>
  );
}

export default EditOrganizationPage;
